import Skeleton from '@carvana/ds-skeleton';
import { HERO_HEIGHT } from './OrderStatusModule/OrderStatusModule.masks';

export default function HeroSectionLoader() {
  return (
    <div className="flex w-full flex-col bg-background-default">
      {/* Mobile (<600px): image on top, content below */}
      <div className="sm:hidden">
        <Skeleton className="!h-[210px] !w-full" />
        <div className="mx-auto w-full max-w-[1352px] p-2xl">
          <div className="flex flex-col gap-32">
            <div className="flex flex-col gap-lg">
              <Skeleton height={28} width="75%" />
              <Skeleton height={28} width="55%" />
            </div>
            <div className="flex flex-col gap-md">
              <Skeleton height={18} width="50%" />
              <Skeleton height={14} width="38%" />
            </div>
            <Skeleton height={44} width={180} className="rounded-full" />
          </div>
        </div>
      </div>

      {/* Tablet (600–1023px): content left, image fills remaining column */}
      <div
        className="hidden w-full overflow-hidden bg-background-default sm:block md:hidden"
        style={{ minHeight: HERO_HEIGHT }}
      >
        <div
          className="mx-auto flex w-full max-w-[1352px] items-center px-3xl"
          style={{ minHeight: HERO_HEIGHT }}
        >
          <div
            className="flex shrink-0 flex-col gap-32 py-40"
            style={{ width: 420 }}
          >
            <div className="flex flex-col gap-lg">
              <Skeleton height={34} width="90%" />
              <Skeleton height={34} width="70%" />
            </div>
            <div className="flex flex-col gap-md">
              <Skeleton height={18} width="65%" />
              <Skeleton height={14} width="50%" />
            </div>
            <Skeleton height={44} width={180} className="rounded-full" />
          </div>
          <Skeleton className="flex-1 !h-[300px]" />
        </div>
      </div>

      {/* Desktop (≥1024px): content left, image fills remaining column */}
      <div
        className="hidden w-full overflow-hidden bg-background-default md:block"
        style={{ height: HERO_HEIGHT }}
      >
        <div className="mx-auto flex h-full w-full max-w-[1352px] sm:pr-3xl lg:pr-4xl">
          <div
            className="flex shrink-0 flex-col justify-center pl-4xl"
            style={{ width: 735 }}
          >
            <div className="flex flex-col gap-32">
              <div className="flex flex-col gap-lg">
                <Skeleton height={44} width="85%" />
                <Skeleton height={44} width="65%" />
              </div>
              <div className="flex flex-col gap-md">
                <Skeleton height={20} width="55%" />
                <Skeleton height={16} width="42%" />
              </div>
              <Skeleton height={48} width={200} className="rounded-full" />
            </div>
          </div>
          <Skeleton className="flex-1 !h-full" />
        </div>
      </div>
    </div>
  );
}
